import React from "react";
import { Navigate, useLocation} from "react-router-dom";

export default function ProtectedRoute({ children, allowedRoles }) {
  const token = localStorage.getItem("token");
  const userStr = localStorage.getItem("user");
  const location = useLocation();
  
  let user = null;

  try {
    user = userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    console.error("Error parsing user:", error);
  }

  // Si no hay token o usuario, redirige a login
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  if (
    user.mustChangePassword &&
    location.pathname !== "/change-password"
  ) {
    return <Navigate to="/change-password" replace />;
  }

  // Si allowedRoles existe, verifica que el rol esté permitido
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Puedes redirigir al root o a login, según prefieras
    return <Navigate to="/" replace />;
  }

  // Si todo está bien, muestra los children (componente protegido)
  return children;
}
